import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ShopsService } from 'src/app/services';
import { NzNotificationService } from 'ng-zorro-antd';
import {recursiveForm} from "../../../business/products/helper/recursive-form.helper";

@Component({
  selector: 'app-add-stores',
  templateUrl: './add-stores.component.html',
  styleUrls: ['./add-stores.component.scss']
})
export class AddStoresComponent implements OnInit, OnDestroy {

  isVisible = false;
  storesId: string;
  isDisable = false;

  showModal(id?: any, data?) {
    this.isVisible = true;
    this.titleId = null;
    this.isShow = false;
    if(data){

    }else {


    }
    this.form.reset();
    this.loadTitle();
    if (id) {
      // new ClickTekoDto('portal_store_products', 'add_product' , 'portal_store_products_create' , {});
      this.storesId = id;
    }
  }

  handleCancel() {
    this.isVisible = false;
  }

  @Output() addStores = new EventEmitter<any>();

  unsubscribe$ = new Subject<void>();
  pageIndex = 1;
  pageSize = 5;

  constructor(
    private fb: FormBuilder,
    private shopService: ShopsService,
    private notification: NzNotificationService,
  ) { }

  openMessage(type: string, title: string, content: any) {
    return this.notification.create(
      type,
      title,
      content
    );
  }

  form = this.fb.group({
    type_id: [null, [Validators.required]],
    product_ids: [null]
  })

  ngOnInit() {
  }

  titleId: number;
  isShow: Boolean = false;
  showProduct(data: any) {
    if (data) {
      this.isShow = true;
      this.titleId = data;
    } else {
      this.isShow = false;
    }
  }

  titles: any = [];
  loadTitle() {
    this.shopService.getAllTitle().subscribe(
      (res) => {
        this.titles = res.data.items;
      },
      (err) => {
        this.openMessage('error', 'Lỗi !!!', `${err}`);
      },
    );
  }

  listProducts(data: any) {
    this.form.get('product_ids').setValue(data);
    if (data.length > 0) {
      this.isRequired = false;
    } else {
      this.isRequired = true;
    }
  }

  isLoadingBtn: Boolean = false;
  isRequired: Boolean;
  onSubmit() {


    recursiveForm(this.form);

    if (this.form.invalid) {
      return;
    }
    if (!this.form.value.product_ids) {
      this.isRequired = true;
      return;
    }
    this.isLoadingBtn = true;
    if (!this.isRequired) {
      let body: any = {
        id: this.storesId,
        type_id: this.form.value.type_id,
        product_ids: this.form.value.product_ids
      }
      this.addStores.emit(body);
      this.isDisable = true;
    }
  }

  success() {
    this.isLoadingBtn = false;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
